var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1564_146272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.87747 4.01172C1.85338 4.01172 0.00393817 5.8374 0.00393817 7.885C0.00393817 9.01207 0.00306302 13.4728 0.00218787 17.9069C0.372813 18.1401 2.15749 18.7126 2.87511 18.7633C4.44676 18.8744 5.4213 18.3548 5.57213 17.0451L5.5642 12.1805H9.04079V16.9339C8.85819 19.6565 6.46941 20.2111 2.83367 20.0278C1.89263 19.9803 0.613229 19.7377 0.0017503 19.5784C0.000875149 24.0163 0 27.9904 0 27.9904C0 27.9904 4.53883 27.9904 6.0504 27.9904C7.70143 27.9904 9.85049 26.4476 9.85049 24.1016C9.85049 20.1646 9.85049 4.01172 9.85049 4.01172C9.85049 4.01172 5.4213 4.01172 3.87747 4.01172Z",
    fill: "url(#paint0_linear_1564_146272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.978 4.01172C12.954 4.01172 11.1045 5.8374 11.1045 7.885C11.1045 8.59906 11.1041 10.6513 11.1036 13.1869C12.3182 12.2383 14.2756 11.7732 16.7666 11.9651C18.1839 12.0742 19.2325 12.2719 19.8039 12.4413V14.124C19.174 13.8097 17.9307 13.3415 16.8935 13.2668C14.544 13.0975 13.311 14.1984 13.311 15.978C13.311 17.5796 14.2636 18.9501 16.883 18.7675C17.747 18.7073 19.1848 18.2039 19.7968 17.9128L19.8039 19.5454C19.2774 19.7114 17.6391 20.0681 16.0971 20.0807C13.7758 20.0996 12.1379 19.6066 11.1025 18.8067C11.1015 23.5448 11.1006 27.9904 11.1006 27.9904C11.1006 27.9904 15.6394 27.9904 17.1509 27.9904C18.802 27.9904 20.9511 26.4476 20.9511 24.1016C20.9511 20.1646 20.9511 4.01172 20.9511 4.01172C20.9511 4.01172 16.5219 4.01172 14.978 4.01172Z",
    fill: "url(#paint1_linear_1564_146272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4598 16.4866C25.797 16.4928 24.3518 16.4799 24.0904 16.4861L24.0864 18.6048L26.4558 18.6126C26.9163 18.6126 27.4956 18.2181 27.4956 17.5309C27.4956 16.9228 26.9956 16.4815 26.4598 16.4866Z",
    fill: "url(#paint2_linear_1564_146272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.208 14.3604C27.208 13.7524 26.751 13.3423 26.2655 13.3536C25.5828 13.3695 24.3518 13.3367 24.0826 13.3606L24.0747 15.2894L26.3131 15.3053C26.6854 15.2977 27.208 14.9565 27.208 14.3604Z",
    fill: "url(#paint3_linear_1564_146272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0269 4.01178C24.0028 4.01178 22.1533 5.83747 22.1533 7.88506C22.1533 8.49854 22.153 10.1007 22.1527 12.1477H27.9041C29.0485 12.1477 30.3963 12.6372 30.3963 14.0287C30.3963 14.775 29.999 15.6203 28.5669 15.8942V15.9259C29.403 15.9259 30.8529 16.4154 30.8529 17.8918C30.8529 19.4158 29.2866 19.839 28.4478 19.839L22.1512 19.8453C22.1503 24.1743 22.1494 27.9904 22.1494 27.9904C22.1494 27.9904 26.6882 27.9904 28.1998 27.9904C29.8508 27.9904 31.9999 26.4476 31.9999 24.1016C31.9999 20.1646 31.9999 4.01172 31.9999 4.01172C31.9999 4.01172 27.5706 4.01178 26.0269 4.01178Z",
    fill: "url(#paint4_linear_1564_146272)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1564_146272",
    x1: 0,
    y1: 16.001,
    x2: 9.85043,
    y2: 16.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B327B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1564_146272",
    x1: 11.1006,
    y1: 16.001,
    x2: 20.951,
    y2: 16.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1564_146272",
    x1: 24.0865,
    y1: 17.5485,
    x2: 27.4956,
    y2: 17.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1564_146272",
    x1: 24.0747,
    y1: 14.3284,
    x2: 27.208,
    y2: 14.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1564_146272",
    x1: 22.1494,
    y1: 16.0011,
    x2: 31.9998,
    y2: 16.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1564_146272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.927604aa0c14fafa5e2a13abf8c39477.svg";
export { ForwardRef as ReactComponent };